export default __webpack_public_path__ + "img/2c0d1813.jpg";